import { useNavigate } from 'react-router-dom'

import { TreeFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import useFlattenedTree from 'modules/job_catalog/hooks/useFlattenedTree'
import useUncollapsedNodes from 'modules/job_catalog/hooks/useUncollapsedNodes'

import Tree from './Tree'

interface Props {
  width: number
  height: number
  treeData: TreeFragment
  zoomToNodeId?: string
}

const JobCatalogTree = ({ width, height, treeData, zoomToNodeId }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const uncollapsedNodes = useUncollapsedNodes(new Set([]))
  const { hierarchy, nodeData } = useFlattenedTree(treeData, uncollapsedNodes.expand)

  const handleCollapseChange = (nodeId: string) => {
    uncollapsedNodes.toggle(nodeId)
  }
  const handleNodeSelection = (nodeId: string) => {
    navigate(
      navigation.employees.jobCatalog.overview.node.fullPath({
        id: nodeId,
      })
    )
  }

  return (
    <Tree
      size={[width, height]}
      hierarchy={hierarchy}
      nodeData={nodeData}
      onNodeSelection={handleNodeSelection}
      onCollapseChange={handleCollapseChange}
      uncollapsedIds={uncollapsedNodes.values}
      zoomToNodeId={zoomToNodeId}
    />
  )
}

export default JobCatalogTree
